import * as z from 'zod';

export const LightingSchema = z.object({
  exteriorLightingControls: z.string().optional(),
});

export type Lighting = z.infer<typeof LightingSchema>;
